/* tslint:disable */
/**
* @module SDKModule
* @author Jonathan Casarrubias <t:@johncasarrubias> <gh:jonathan-casarrubias>
* @license MIT 2016 Jonathan Casarrubias
* @version 2.1.0
* @description
* The SDKModule is a generated Software Development Kit automatically built by
* the LoopBack SDK Builder open source module.
*
* The SDKModule provides Angular 2 >= RC.5 support, which means that NgModules
* can import this Software Development Kit as follows:
*
*
* APP Route Module Context
* ============================================================================
* import { NgModule }       from '@angular/core';
* import { BrowserModule }  from '@angular/platform-browser';
* // App Root 
* import { AppComponent }   from './app.component';
* // Feature Modules
* import { SDK[Browser|Node|Native]Module } from './shared/sdk/sdk.module';
* // Import Routing
* import { routing }        from './app.routing';
* @NgModule({
*  imports: [
*    BrowserModule,
*    routing,
*    SDK[Browser|Node|Native]Module.forRoot()
*  ],
*  declarations: [ AppComponent ],
*  bootstrap:    [ AppComponent ]
* })
* export class AppModule { }
*
**/
import { ErrorHandler } from './services/core/error.service';
import { LoopBackAuth } from './services/core/auth.service';
import { LoggerService } from './services/custom/logger.service';
import { SDKModels } from './services/custom/SDKModels';
import { InternalStorage, SDKStorage } from './storage/storage.swaps';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CookieBrowser } from './storage/cookie.browser';
import { StorageBrowser } from './storage/storage.browser';
import { SocketBrowser } from './sockets/socket.browser';
import { SocketDriver } from './sockets/socket.driver';
import { SocketConnection } from './sockets/socket.connections';
import { RealTime } from './services/core/real.time';
import { AccessTokenApi } from './services/custom/AccessToken';
import { AppSettingsApi } from './services/custom/AppSettings';
import { CoachApi } from './services/custom/Coach';
import { EmailApi } from './services/custom/Email';
import { SystemApi } from './services/custom/System';
import { PatientApi } from './services/custom/Patient';
import { PatientTokenApi } from './services/custom/PatientToken';
import { SurveyApi } from './services/custom/Survey';
import { ReplicationEndpointApi } from './services/custom/ReplicationEndpoint';
import { DeviceApi } from './services/custom/Device';
import { PatientPukApi } from './services/custom/PatientPuk';
import { SyncedPatientsApi } from './services/custom/SyncedPatients';
import { ExternalInterfaceApi } from './services/custom/ExternalInterface';
import { CostRateApi } from './services/custom/CostRate';
import { CommentApi } from './services/custom/Comment';
import { DiagnosisApi } from './services/custom/Diagnosis';
import { ExternalCommentsApi } from './services/custom/ExternalComments';
import { SurveyQuestionApi } from './services/custom/SurveyQuestion';
import { SurveyAnswerApi } from './services/custom/SurveyAnswer';
import { QuestionAnswerMappingApi } from './services/custom/QuestionAnswerMapping';
import { LogApi } from './services/custom/Log';
import { NewsInterfaceApi } from './services/custom/NewsInterface';
import { PodcastActivityApi } from './services/custom/PodcastActivity';
import { SkincareCountApi } from './services/custom/SkincareCount';
import { SkinConditionApi } from './services/custom/SkinCondition';
import { UserGoalEvaluationApi } from './services/custom/UserGoalEvaluation';
import { AppSurveyApi } from './services/custom/AppSurvey';
import { UserGoalApi } from './services/custom/UserGoal';
/**
* @module SDKBrowserModule
* @description
* This module should be imported when building a Web Application in the following scenarios:
*
*  1.- Regular web application
*  2.- Angular universal application (Browser Portion)
*  3.- Progressive applications (Angular Mobile, Ionic, WebViews, etc)
**/
@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [ ],
  exports:      [ ],
  providers:    [
    ErrorHandler,
    SocketConnection
  ]
})
export class SDKBrowserModule {
  static forRoot(internalStorageProvider: any = {
    provide: InternalStorage,
    useClass: CookieBrowser
  }): ModuleWithProviders {
    return {
      ngModule  : SDKBrowserModule,
      providers : [
        LoopBackAuth,
        LoggerService,
        SDKModels,
        RealTime,
        AccessTokenApi,
        AppSettingsApi,
        CoachApi,
        EmailApi,
        SystemApi,
        PatientApi,
        PatientTokenApi,
        SurveyApi,
        ReplicationEndpointApi,
        DeviceApi,
        PatientPukApi,
        SyncedPatientsApi,
        ExternalInterfaceApi,
        CostRateApi,
        CommentApi,
        DiagnosisApi,
        ExternalCommentsApi,
        SurveyQuestionApi,
        SurveyAnswerApi,
        QuestionAnswerMappingApi,
        LogApi,
        NewsInterfaceApi,
        PodcastActivityApi,
        SkincareCountApi,
        SkinConditionApi,
        UserGoalEvaluationApi,
        AppSurveyApi,
        UserGoalApi,
        internalStorageProvider,
        { provide: SDKStorage, useClass: StorageBrowser },
        { provide: SocketDriver, useClass: SocketBrowser }
      ]
    };
  }
}
/**
* Have Fun!!!
* - Jon
**/
export * from './models/index';
export * from './services/index';
export * from './lb.config';
export * from './storage/storage.swaps';
export { CookieBrowser } from './storage/cookie.browser';
export { StorageBrowser } from './storage/storage.browser';

